var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.6 5L21 6.4L8.4 19L2 12.6L3.33935 11.2651L8.4 16.2047L19.6 5Z","fill":"white"}));
}

CheckInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":""};

module.exports = CheckInline;

CheckInline.default = CheckInline;
